import React from 'react';
import { createUseStyles } from 'react-jss';

import MenuItem from '../../../MenuItem';
import ToggleButton from '../../../ToggleButton';
import { useToggle } from '../../../../hooks/useToggle';

const useStyles = createUseStyles((theme) => ({
  immatriculation: {
    composes: 'flexColumn stretchSelf flex1',
  },
  top: {},
  bottom: {},
  items: {
    padding: 0,
    margin: 0,
    '& li': {
      listStyle: 'none',
    },
  },
  body: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const Immatriculation = ({ result }) => {
  const classes = useStyles();

  const { open, toggle } = useToggle();

  return (
    <div className={classes.immatriculation}>
      <div className={classes.top}>
        <MenuItem 
          label="Date Immatriculation :" 
          text={result?.date_immatriculation} 
          customValue={new Date(result?.date_immatriculation.raw).toLocaleDateString('en-US')}
          component="div" 
        />

        <div className={classes.body}>
          <ul className={classes.items}>
          <MenuItem label="Turn Over" text={result?.turnover} />
          <MenuItem label="Effectifs" text={result?.cie_employees} />
          </ul>
        </div>
        <MenuItem label="Siren : " text={result?.siren} component="div" />
      </div>

      <div className={classes.bottomm}>
        <ul className={classes.items}>
          <li>
            <ToggleButton onClick={toggle} open={open} />
          </li>
          {open && (
            <>
              <MenuItem label="Zip :" text={result?.cie_cie_zip} />
              <MenuItem label="Followers :" text={result?.cie_followers} />
              <MenuItem label="Size :" text={result?.cie_size} />
              <MenuItem label="Capital :" text={result?.capital} />
              <MenuItem label="Net Investment :" text={result?.net_investment} />
              <MenuItem label="Financial debt :" text={result?.financial_debt} />
              <MenuItem label="Notoriety :" text={result?.cie_notoriety} />
              <MenuItem label="Cash :" text={result?.cash} />
              <MenuItem label="Industry :" text={result?.cie_industry} />
              <MenuItem label="Net Assets :" text={result?.net_assets} />
            </>
          )}
        </ul>
      </div>
    </div>
  );
}

export default Immatriculation;